<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title"> <span v-html="title"></span> Перепривязать к новому менеджеру?</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__btns">
				<button class="btn btn--color" @click.prevent="$emit('forceUpdate')">Да</button>
				<button class="btn btn--border" @click="$emit('close')">Нет</button>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "ApproveReplacePopup",
	props: {
		title: {
			type: String,
			default: 'Товарная категория привязана к другому поставщику'
		}
	},
}
</script>

